import { z } from 'zod';
export const premiumPlanCodeSchema = z.enum(['month', 'year', 'two-years']);
export const premiumCheckoutSchema = z.object({ plan: premiumPlanCodeSchema }).strict();
/**
 * Эмодзи-статус подписчика — из готового набора, а не любой символ: иначе
 * рядом с именем оказалось бы что угодно, в том числе похожее на знак
 * подтверждённого аккаунта.
 */
export const EMOJI_STATUSES = [
    '🔥',
    '⭐',
    '💎',
    '🚀',
    '🎧',
    '🎮',
    '📚',
    '💼',
    '☕',
    '🌙',
    '🌿',
    '❤️',
    '😎',
    '🎨',
    '✈️',
    '🏆'
];
/** Цвет профиля — индекс в той же палитре, что у аватаров без фотографии. */
export const PROFILE_ACCENT_COUNT = 8;
/** Оформление подписчика. `null` — убрать; отсутствие поля — не трогать. */
export const premiumLookSchema = z
    .object({
    emojiStatus: z.enum(EMOJI_STATUSES).nullable().optional(),
    profileAccent: z
        .number()
        .int()
        .min(0)
        .max(PROFILE_ACCENT_COUNT - 1)
        .nullable()
        .optional()
})
    .strict()
    .refine((value) => Object.keys(value).length > 0, 'Нет изменений');
//# sourceMappingURL=premium.js.map